<section class="floating-panel-wrapper">
  <div class="floating-panel-icon"  *ngIf="!panelOpen">
    <gen-data-notification [formId]="dataNotificationformId" [updated]="updated"></gen-data-notification>
    <i class="icon__Notes"
       (click)="openPanel()">
    </i>
  </div>

  <section #itemsPanel
           class="floating-panel-container decision-capture {{floatingWidgetPayload.styleClass}}"
           *ngIf="panelOpen"
           [ngClass]="{'floating-panel-container-nobg': fixedPanel, 'floating-panel-container-bg': !fixedPanel}"
           [ngStyle]= "{'width': floatingPanelWidth}">
    <div *ngIf="!fixedPanel" class="close-icon">
      <i class="icon__cross close-btn Auto_Btn_Close"
         (click)="closePanel()">
      </i>
    </div>
    <div class="floating-panel-title">{{title | translate}}</div>
    <gen-dynamic-form *ngFor="let formPayload of formsPayload; let i = index"
                      class="info-dynamic-form"
                      [formName]="formPayload.formId"
                      [formData]="formData"
                      [formVertical]="true"
                      [updateOnBlur]="false"
                      [editMode]="true"
                      [popupMode]="false"
                      (formChange)="formChanged($event, i)"
                      [mapAllProperties]="true"
                      [submitted]="submitted"
                      [resetForm]="resetForm"
                      [submitButtonText]="permitItemSelectionWrite? submitButtonName : null"
                      (submitEmitter)="submit($event)"
                      [additionalSearchValues]="additionalSearchValues"
                      (validateChange)="updateValidate($event)"
                      flagDiffFieldsOnUpdate="true"
    >
    </gen-dynamic-form>

    <gen-overlay-loader [loaderType]="'SKELETON-PLAIN'"  *ngIf="loading"  class="overlay-loader-position" [showOverlay]="true"></gen-overlay-loader>

  </section>

</section>
